import React from 'react';
import { Button, Card } from 'antd';
import ErrorBg from '../../assets/modal_error_bg.png';
import './errorCard.less';

const ErrorCard = ({ title, caption, buttonText, buttonClickHandler }) => {
    const { Meta } = Card;
    return (
        <Card
            hoverable
            className='error-card'
            style={{ width: 240 }}
            cover={<img alt="errorBg" src={ErrorBg} />}
        >
            <Meta title={title} description={caption} />
            {buttonText && buttonClickHandler && (
                <Button type="primary" className='error-card-button' onClick={buttonClickHandler}>
                    {buttonText}
                </Button>
            )}
        </Card>
    );
}

export default ErrorCard;